import { Button, IconButton, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { ITableColumn, TableList } from "src/components/table";
import CardActions from "src/pages/sistema/components/CardActions";
import { ICON_MAS } from "src/pages/sistema/components/SharedIcons";
import { DialogNuevoDetalle } from "./DialogNuevoDetalle";
import { DetalleFields } from "../api/detalle-fields";
import { useDetalles } from "../hooks/useDetalles";
import { EntityWithIdFields, QueryStatus } from "src/types";
import DeleteIcon from '@mui/icons-material/Delete';
import { deleteOperationDetail } from "../api/delete-detail";
import { Detalle } from "../api/get-detalles";
import toast from "react-hot-toast";
import { useConfirmationDialog } from "src/hooks/useConfirmationDialog";

type SeccionWRCDetalle = {
    idOperacion: number
    idPais: number
    permiteEditar: boolean
    permiteEliminar: boolean
}

const SeccionWRCDetalle = ({ idOperacion, idPais, permiteEditar, permiteEliminar }: SeccionWRCDetalle) => {

    const [openDialog, setOpenDialog] = useState<boolean>(false);

    const { status, detalles, refetch } = useDetalles(idOperacion);

    const { askConfirmation } = useConfirmationDialog();

    const columnsTablaWRCDetalle: ITableColumn[] = [
        { label: 'Operación', value: DetalleFields.DescripcionOperacionTipo },
        { label: 'Excepción', value: DetalleFields.DescripcionExcepcion },
        {
            label: 'Acciones', onRenderCell: (entity: Detalle) => (
                <>
                    {
                        permiteEliminar &&
                        <Tooltip title='Eliminar'>
                            <IconButton onClick={
                                () => askConfirmation(
                                    () => {
                                        const promise = deleteOperationDetail(entity[DetalleFields.IdOperacion], entity[EntityWithIdFields.Id])

                                        toast.promise(promise, {
                                            success: 'Eliminado',
                                            error: 'No se pudo eliminar',
                                            loading: 'Eliminando'
                                        }).then(() => refetch())
                                    }
                                )
                            }
                            >
                                <DeleteIcon color='error' />
                            </IconButton>
                        </Tooltip>
                    }
                </>
            ),
            width: 0.1
        }
    ]

    useEffect(() => {
        if (!openDialog) refetch()
    }, [openDialog])

    // TODO: el content del dialog debería ir a otro component, no su contenido
    return (
        <CardActions
            title={"Detalles"}
            actions={
                permiteEditar &&
                <Button variant="contained" color="primary" endIcon={ICON_MAS} onClick={() => setOpenDialog(true)}>
                    Nuevo
                </Button>
            }
            colapsable
            tableContent
        >
            <TableList
                entityList={detalles}
                columns={columnsTablaWRCDetalle}
                isLoading={status === QueryStatus.Loading}
                error={status === QueryStatus.Error}
            />
            {
                openDialog &&
                <DialogNuevoDetalle
                    open={openDialog}
                    setOpen={setOpenDialog}
                    idOperacion={idOperacion}
                    idPais={idPais}
                />
            }
        </CardActions>
    )
}

export default SeccionWRCDetalle;
